import { message } from "antd";
import { baseRequest } from "../../util/Api";

export const syncMutations = () => {
  return new Promise((resolve, reject) => {
    baseRequest("post", "/mesin-otomatis/sync")
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}